module.exports = __webpack_public_path__ + "img/direct-messages.57cdd536.svg";